var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconArrowDown = function SvgIconArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.32 5.661a.57.57 0 0 1 .016.816L8.667 10.22a.935.935 0 0 1-1.334 0L3.664 6.477a.57.57 0 0 1 .016-.816.594.594 0 0 1 .83.016L8 9.237l3.49-3.56a.594.594 0 0 1 .83-.016Z",
    fill: "current"
  })));
};
export default SvgIconArrowDown;